document.addEventListener('DOMContentLoaded', () => {
    if ($(window).width() > 1101) {
      $(window).scroll(function () {
        if ($(window).scrollTop() + ($(window).height() * 2) / 3 > $('.aph320-vertical').offset().top) {
          $('.aph320-vertical').addClass('animate-text');
        } else {
          $('.aph320-vertical').removeClass('animate-text');
        }
      });
    }
  });